import './ContentPage.css';
import Footer from '../components/Footer.js'; 

const Industry = ({ title, content }) => {
  return (
    <div>
    <div className="content-page">
      <section className="content-hero">
        <h1 className="hero-title">Focus Industry</h1>
        <div className="hero-decor"></div>
      </section>

      <section className="content-section">
        <div className="content-card reveal active">
          <div className="text-container">
            <p className="content-text">At Kagwe, Kamau & Karanja Advocates,, we provide comprehensive real estate legal consultancy tailored to the needs of developers, investors, property owners, landlords, tenants, and management entities. Our services cover the full property lifecycle—from pre-development due diligence and regulatory compliance to project financing and conveyancing. We handle all aspects of documentation, including drafting, verification, and execution. With a proven track record in both residential and commercial developments across Kenya, we ensure smooth transitions from project inception to completion. Our focus on quality, efficiency, and cost-effective solutions positions us as a trusted legal advisor in the real estate sector.</p>
          </div>
          <div className="interactive-element">
            <div className="hover-circle"></div>
            <div className="hover-circle"></div>
          </div>
        </div>
      </section>

    </div>
            <Footer />
    </div>
  );
};

export default Industry;